import { WatchQueryFetchPolicy } from '@apollo/client';

import { useLoggingQuery } from 'lib/apollo/apollo-hooks';
import {
  GET_LESSON_TEACHING_LEARNING_SEQUENCE,
  GET_ALL_DEFINED_TEACHING_AND_LEARNING_STRATEGIES,
} from './teaching-notes.graphql';
import { useSnackbar } from 'approot/shared/snackbar-notification/snackbar-notification.hooks';
import {
  GetLessonTeachingAndLearningSequence,
  GetLessonTeachingAndLearningSequenceVariables,
} from './__generated__/GetLessonTeachingAndLearningSequence';
import { GetAllDefinedTeachingAndLearningStrategies } from './__generated__/GetAllDefinedTeachingAndLearningStrategies';

type GetSequencesProps = {
  contentId: number;
  fetchPolicy?: WatchQueryFetchPolicy;
  version?: string | null;
  skip?: boolean;
  authenticate?: boolean;
};

export const useGetLessonSequences = ({
  contentId,
  fetchPolicy = 'cache-first',
  version,
  skip,
  authenticate = true,
}: GetSequencesProps) => {
  const { showError } = useSnackbar();
  const { data, loading, error } = useLoggingQuery<
    GetLessonTeachingAndLearningSequence,
    GetLessonTeachingAndLearningSequenceVariables
  >(
    GET_LESSON_TEACHING_LEARNING_SEQUENCE,
    {
      variables: {
        input: {
          contentId,
          version: version || undefined,
        },
      },
      fetchPolicy,
      skip,
      onError: () => showError('There was an error retrieving teaching notes'),
    },
    authenticate
  );
  const sequences = data?.getLessonTeachingAndLearningSequence || null;

  return {
    sequences,
    loading,
    error,
  };
};

export const useTeachingAndLearningStrategyData = (props?: {
  fetchPolicy?: WatchQueryFetchPolicy;
}) => {
  const { data, loading, error } = useLoggingQuery<
    GetAllDefinedTeachingAndLearningStrategies,
    null
  >(GET_ALL_DEFINED_TEACHING_AND_LEARNING_STRATEGIES, {
    fetchPolicy: props?.fetchPolicy || 'cache-first',
  });

  return {
    data: data?.getAllDefinedTeachingAndLearningStrategies,
    loading,
    error,
  };
};
